export const textFilterProcessor = ({ inputQuery/*, query*/, key, filter }) => {
	// const value = query[key] ?? '';
	const inputValue = inputQuery[key] ?? '';

	return {
		...filter,
		key,
		active: !!inputValue.length,
		value: inputValue,
		sumText: inputValue,
	}
}